import { onPageIn, onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  let observer: IntersectionObserver | null = null

  onMount(() => {
    // Find all visionary card columns
    const cardCols = element.querySelectorAll('.visionary_card_col')

    if (cardCols.length === 0) return

    // Create IntersectionObserver with lower threshold
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const cardCol = entry.target as HTMLElement
          const indicator = cardCol.querySelector(
            '.visionary_card_timeline_indicator'
          ) as HTMLElement

          if (indicator) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.9) {
              // 90% visible - apply border color (and keep it)
              indicator.style.borderColor = '#1111121A'
            }
          }
        })
      },
      {
        threshold: [0.9, 1], // Trigger when 90% or fully visible
        rootMargin: '0px',
      }
    )

    // Observe all card columns
    cardCols.forEach((col) => {
      observer?.observe(col)
    })
  })

  onDestroy(() => {
    // Disconnect observer
    if (observer) {
      observer.disconnect()
      observer = null
    }
  })
}
